import {
  Paper,
  Table,
  TableHead,
  TableRow,
  Typography,
  TableCell,
  TableBody,
  TablePagination,
  TableContainer,
  Grid,
  TextField,
  Button,
} from "@mui/material";
import React, { useState, useEffect } from "react";

const DesktopList = ({
  setFocusedCircuit,
  setCurrentPage,
  circuits,
  order,
  setOrder,
  orderBy,
  setOrderBy,
  searchBar,
  setSearchBar,
  displayConnections,
  setDisplayConnections,
}) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(12);
  const viewCircuit = (circuit) => {
    setFocusedCircuit(circuit);
    setCurrentPage("detail");
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const descendingComparator = (a, b, orderBy) => {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  };

  const getComparator = (order, orderBy) => {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  };

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  useEffect(() => {
    search();
    // eslint-disable-next-line
  }, [searchBar, circuits]);

  const search = () => {
    if (circuits !== null && circuits !== undefined) {
      const searchResults = circuits.filter((connection) => {
        const regex = new RegExp(`${searchBar}`, "gi");

        return (
          connection.company.match(regex) ||
          connection.location.match(regex) ||
          connection.connection_account_num.match(regex) ||
          connection.MSISDN.match(regex)
        );
      });
      setDisplayConnections(searchResults);
    }
  };

  const handleSearch = (e) => {
    setSearchBar(e.target.value);
  };

  return (
    <Paper
      elevation={8}
      sx={{
        py: 4,
        px: { xs: 1, sm: 2, md: 10, l: 30, xl: 40 },
        // display: { xs: "none", sm: "block" },
        minHeight: "90vh",
        overflow: "hidden",
      }}
    >
      <Grid
        container
        sx={{
          display: "flex",
          flexDirection: { xs: "column-reverse", md: "row" },
        }}
      >
        <Grid item xs={12} lg={4}>
          <TextField
            label="Search"
            type="search"
            sx={{ width: { xs: "100%", md: "90%" } }}
            onChange={handleSearch}
            value={searchBar}
          ></TextField>
        </Grid>
        <Grid item xs={12} lg={4}>
          <Typography
            variant="h4"
            color="primary"
            sx={{ textAlign: "center", justifyContent: "center" }}
          >
            CIRCUITS
          </Typography>
        </Grid>
        <Grid item xs={12} lg={4}>
          <Button
            variant="contained"
            color="success"
            onClick={() => setCurrentPage("create")}
            sx={{ float: "right", mr: 3 }}
          >
            ADD
          </Button>
        </Grid>
      </Grid>
      <TableContainer sx={{ maxHeight: 700, mt: 2 }}>
        <Table size="large" stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow sx={{}}>
              <TableCell
                sx={{
                  color: "#e2e2e2",
                  background: "#2e68b1",
                  cursor: "pointer",
                }}
                onClick={() => handleRequestSort("company")}
              >
                Company
              </TableCell>
              <TableCell
                sx={{
                  color: "#e2e2e2",
                  textAlign: "center",
                  background: "#2e68b1",
                  cursor: "pointer",
                }}
                onClick={() => handleRequestSort("siteName")}
              >
                Site Name
              </TableCell>
              <TableCell
                sx={{
                  color: "#e2e2e2",
                  textAlign: "center",
                  background: "#2e68b1",
                  cursor: "pointer",
                }}
                onClick={() => handleRequestSort("connection_account_num")}
              >
                Account #
              </TableCell>
              <TableCell
                sx={{
                  color: "#e2e2e2",
                  textAlign: "center",
                  background: "#2e68b1",
                  cursor: "pointer",
                }}
                onClick={() => handleRequestSort("MSISDN")}
              >
                Mobile ID
              </TableCell>
              <TableCell
                sx={{
                  color: "#e2e2e2",
                  textAlign: "center",
                  background: "#2e68b1",
                  cursor: "pointer",
                }}
                onClick={() => handleRequestSort("device")}
              >
                Device
              </TableCell>
              <TableCell
                sx={{
                  color: "#e2e2e2",
                  textAlign: "center",
                  background: "#2e68b1",
                  cursor: "pointer",
                }}
                onClick={() => handleRequestSort("abt_rate_plan")}
              >
                Rate Plan
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {displayConnections !== null && displayConnections !== undefined
              ? displayConnections
                  .sort(getComparator(order, orderBy))
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((circuit) => (
                    <TableRow
                      hover
                      key={circuit._id}
                      onClick={() => viewCircuit(circuit)}
                      sx={{ cursor: "pointer" }}
                    >
                      <TableCell>{circuit.company}</TableCell>
                      <TableCell sx={{ textAlign: "center" }}>
                        {circuit.location}
                      </TableCell>
                      <TableCell sx={{ textAlign: "center" }}>
                        {circuit.connection_account_num}
                      </TableCell>
                      <TableCell sx={{ textAlign: "center" }}>
                        {circuit.MSISDN}
                      </TableCell>
                      <TableCell sx={{ textAlign: "center" }}>
                        {circuit.device}
                      </TableCell>
                      <TableCell sx={{ textAlign: "center" }}>
                        {circuit.abt_rate_plan}
                      </TableCell>
                    </TableRow>
                  ))
              : null}
          </TableBody>
        </Table>
      </TableContainer>
      {displayConnections !== null &&
      displayConnections !== undefined &&
      displayConnections.length > 12 ? (
        <TablePagination
          rowsPerPageOptions={[12, 25, 50, 100]}
          component="div"
          count={displayConnections.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          sx={{
            color: "#e2e2e2",
            backgroundColor: "#2e68b1",
          }}
        />
      ) : null}
    </Paper>
  );
};

export default DesktopList;
